import { ExternalLinkIcon } from '@/components';
import { Flex } from '@blockanalitica/ui';

export default function ExternalLink({
  icon = null,
  iconSize = 16,
  children = undefined,
  ...rest
}) {
  return (
    <Flex
      as="a"
      display="flex"
      target="_blank"
      rel="noreferrer"
      gap="3xs"
      alignItems="center"
      {...rest}>
      {children}
      {icon ? icon : <ExternalLinkIcon size={iconSize} />}
    </Flex>
  );
}
